var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.permissionType !== 'App Permission')?_c('v-chip',{staticClass:"permission-badge",class:{
      'permission-badge--admin': _vm.isAdminPermission,
      'permission-badge--owner': _vm.isOwnerRole,
    },attrs:{"color":_vm.getBadgeColor(),"label":"","readonly":_vm.getReadonlyStatus()}},[(_vm.permissionType !== 'App Permission')?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.permissionType))]):_vm._e()]):_c('div',[(_vm.appDropdown && _vm.permissionType === 'App Permission')?_c('Icon',{attrs:{"name":_vm.generateIconName()}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }